
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/personbil",
      function () {
        return require("private-next-pages/wheels/personbil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/personbil"])
      });
    }
  